import React from "react";

export default function SQL_Drop_DB() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Drop_DB</h1>
      <p>This is the SQL_Drop_DB component generated from the SQL JSON.</p>
    </div>
  );
}
